import _ from 'lodash'
import moment from 'moment'

export const encryptCellphone = (str) => {
  str = str ? `${str.slice(0, 4)}****${str.slice(-3)}` : ''
  return str
}

export const replaceBankcardNumWithStar = (str) => {
  str = `${str}`
  // return '*'.repeat(str.length - 4) + str.slice(-4)
  return str.slice(0, str.length - 4).replace(/\d/g, '*') + str.slice(-4)
}

export const formatDate = (str, format) => moment(str).format(format)

export const addThousandSign = (num, digits = 0) => {
  num = Number(num)
  return !_.isNaN(num) ? (`${num.toFixed(digits)}`).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,') : ''
}

export const addBankcardNumSpaces = (str) => {
  const spaceRE = /(\s*)/g  // 正则-所有空格
  const spaceEndRE = /(\s*$)/g  // 正则-末位空格
  const spaceStr = str.replace(spaceRE, '').replace(/(\d{4})(?=\d)/g, '$1 ')
  return spaceStr.replace(spaceEndRE, '') // 替换末位空格
}



// WEBPACK FOOTER //
// ./src/filters/index.js